import { createStyles, makeStyles } from "@material-ui/core/styles";

import theme from "@/theme";

// Master TopBar: 高さ64px、内側1200px。
export const PC_HEADER_HEIGHT = 64;

export const useTopBarStyles = makeStyles(() =>
  createStyles({
    appBar: {
      height: PC_HEADER_HEIGHT,
      boxSizing: "border-box",
      backgroundColor: theme.palette.semantic["surface/card"],
      color: theme.palette.text.primary,
      borderBottom: `1px solid ${theme.palette.semantic["border/default"]}`,
    },
    toolBar: {
      width: "100%",
      maxWidth: 1232,
      margin: "0 auto",
      height: PC_HEADER_HEIGHT - 1,
      minHeight: PC_HEADER_HEIGHT - 1,
      padding: "0 16px",
      gap: 32,
      [theme.breakpoints.down("md")]: { gap: 16 },
    },
    logoImage: { width: 104, height: 37, objectFit: "contain", flexShrink: 0 },
    nav: {
      display: "flex",
      alignItems: "center",
      gap: 8,
      flex: 1,
      minWidth: 0,
      [theme.breakpoints.down("md")]: { gap: 0 },
    },
    navItem: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 8,
      padding: "8px 12px",
      textDecoration: "none",
      color: theme.palette.text.secondary,
      whiteSpace: "nowrap",
      "& .MuiSvgIcon-root": { width: 20, height: 20, color: theme.palette.semantic["icon/default"] },
      [theme.breakpoints.down("md")]: { padding: "8px 4px" },
      "&:hover": { color: theme.palette.primary.main },
    },
    navItemActive: {
      color: theme.palette.primary.main,
      "& .MuiSvgIcon-root": { color: "inherit" },
    },
    navLabel: { fontSize: 14, fontWeight: 400, lineHeight: 1.5 },
    settings: {
      width: 40,
      height: 40,
      padding: 10,
      marginLeft: "auto",
      flexShrink: 0,
      color: theme.palette.semantic["icon/default"],
      "& .MuiSvgIcon-root": { width: 20, height: 20 },
    },
  })
);
